import { BrowserRouter } from 'react-router-dom';
import FullScreenContextProvider from './context/FullScreenContext';
import FirebaseContextProvider from './context/FirebaseContext';
import Routes from './Routes';
import { QueryClient, QueryClientProvider } from 'react-query';
import React, { useState, useEffect } from 'react';
import { ThemeProvider } from './context/ThemeContext.js';
import NecttosContextProvider from './context/NecttosContext';
import Auth from './Lauch/Auth';

function NectosDash() {
	const queryClient = new QueryClient();

	const [isOffline, setIsOffline] = useState(false);

	const checkOnlineStatus = () => {
		setIsOffline(!navigator.onLine);
		if (!navigator.onLine) {
			// setModalOpen(true);
		}
	};

	useEffect(() => {
		checkOnlineStatus();

		const interval = setInterval(() => {
			checkOnlineStatus();
		}, 5000);

		window.addEventListener('online', checkOnlineStatus);
		window.addEventListener('offline', checkOnlineStatus);

		return () => {
			clearInterval(interval);
			window.removeEventListener('online', checkOnlineStatus);
			window.removeEventListener('offline', checkOnlineStatus);
		};
	}, []);

	return (
		<QueryClientProvider client={queryClient}>
			<FirebaseContextProvider>
				<NecttosContextProvider>
					<ThemeProvider>
						<FullScreenContextProvider>
							<BrowserRouter>
								<Auth>
									<Routes />
								</Auth>
							</BrowserRouter>
						</FullScreenContextProvider>
					</ThemeProvider>
				</NecttosContextProvider>
			</FirebaseContextProvider>
		</QueryClientProvider>
	);
}

export default NectosDash;
